import { useEffect, useState } from "react";
import { getAuditByModule } from "../../../services/api/qa/auditService";
import AuditFilters from "./components/AuditFilters";
import AuditTable from "./components/AuditTable";

function ModuleAuditPage({ module }) {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);

  useEffect(() => {
    fetchLogs();
  }, [module]);

  const fetchLogs = async () => {
    try {
      const data = await getAuditByModule(module);
      console.log("Fetched audit logs:", data);
      setLogs(data);
      setFilteredLogs(data);
    } catch (err) {
      console.error("Failed to load audit logs", err);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4 capitalize">
        {module} Audit Logs
      </h2>

      <AuditFilters logs={logs} setFilteredLogs={setFilteredLogs} />

      <AuditTable logs={filteredLogs} />
    </div>
  );
}

export default ModuleAuditPage;